import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CreateTag from "./CreateTag";
import CreateTagSetting from "./CreateTagSetting";
import { getFileUrl, getPresignedUrl, uploadFile } from "../../../../../api/FilesController";
import CreatePopup from "./CreatePopup";
import { addClientTag, addRoomAndAchievementByClientTag } from "../../../../../api/ClientsTagController";

const CreateClientTag = () => {
    const [step, setStep] = useState(1);
    const token = useSelector((state) => state?.user?.token);
    const [bannerType, setBannerType] = useState("");

    const [tagState, setTagState] = useState({
        clientTag: "",
        clientTagMeta: {},
        roomIds: [],
        achievementIds: [],
        presetId: "",
        // achievementActive: false,
    });

    const [tagSettingState, setTagSettingState] = useState({
        settingPresetName: "",
        loadingScreenImageUrl: { default: "" },
        loadingMessage: { default: "" },
        loginText: "",
        loginUrl: "",
        metaData: {},
    });

    const [tagPopupState, setTagPopupState] = useState([
        {
            unityPopupId: "",
            isEnabled: false,
            triggerType: "",
            triggerValue: {},
            metadata: {},
        },
    ]);

    const handleSubmit = async () => {
        try {
            const response = await addClientTag(tagState, tagSettingState, tagPopupState);
            if (response?.status === 200 || response?.status === 201) {
                try {
                    const bodyData = {
                        rooms: tagState.roomIds,
                        roomPresetId: tagState.presetId,
                        achievements: tagState.achievementIds,
                    };
                    const addRoomAchievementResponse = await addRoomAndAchievementByClientTag(bodyData, tagState.clientTag);
                    if (addRoomAchievementResponse.status === 200 || addRoomAchievementResponse.status === 201) {
                        setBannerType("SUCCESS");
                    }
                } catch (error) {
                    console.error("Error creating client tag:", error);
                    setBannerType("ERROR");
                }
            } else {
                console.error("Error creating client tag:", response);
                setBannerType("ERROR");
            }
        } catch (error) {
            console.error("Error creating client tag:", error);
            setBannerType("ERROR");
        }
    };

    const uploadLoadingScreenImage = (file) => {
        const data = {
            file,
            usageType: "roomDetailsImage",
        };
        return uploadFile(data, token)
            .then((response) => {
                if (response.status === 200) {
                    const imageId = response.data.id;
                    return getPresignedUrl([imageId]).then((res) => {
                        setTagSettingState((prevState) => ({
                            ...prevState,
                            loadingScreenImageUrl: { default: res.data.presignedUrls[0].url },
                        }));
                        // Return the original upload response here
                        return response;
                    });
                }
                console.error("File upload failed:", response);
                return response;
            })
            .catch((error) => {
                console.error("Error uploading file:", error);
                return { status: "ERROR", error };
            });
    };

    return (
        <>
            {step === 1 && (
                <CreateTag
                    tagState={tagState}
                    setTagState={setTagState}
                    tagSettingState={tagSettingState}
                    setTagSettingState={setTagSettingState}
                    step={step}
                    setStep={setStep}
                    uploadLoadingScreenImage={uploadLoadingScreenImage}
                />
            )}
            {/* {step === 2 && (
                <CreateTagSetting
                    tagSettingState={tagSettingState}
                    setTagSettingState={setTagSettingState}
                    step={step}
                    setStep={setStep}
                    uploadLoadingScreenImage={uploadLoadingScreenImage}
                />
            )} */}
            {step === 2 && (
                <CreatePopup
                    tagPopupState={tagPopupState}
                    setTagPopupState={setTagPopupState}
                    bannerType={bannerType}
                    setBannerType={setBannerType}
                    handleSubmit={handleSubmit}
                />
            )}
            {/* {step === 4 && <div>Step 4 Content</div>} */}
        </>
    );
};

export default CreateClientTag;
